import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CookieConsent extends Vue {
  isConsentGiven: boolean = false;

  mounted() {
    if (process.client) {
      const consent = localStorage.getItem('cookieConsent');
      this.isConsentGiven = consent === 'true';
    }
  }

  acceptCookies() {
    if (process.client) {
      localStorage.setItem('cookieConsent', 'true');
    }
    this.isConsentGiven = true;
  }

  render(h: Function) {
    if (this.isConsentGiven) return null;
    return (
      <div style={styles.wrapper}>
        <div style={styles.container}>
          <span style={styles.text}>
            24farmacia использует cookie-файлы и обрабатывает персональные данные с использованием Яндекс Метрики. Это улучшает работу сайта и взаимодействие с ним. Подтвердите ваше согласие, нажав кнопку Ок.
          </span>
          <button
            style={styles.button}
            onMouseenter={styles.onEnter}
            onMouseleave={styles.onLeave}
            onClick={this.acceptCookies}
          >
            Ок
          </button>
        </div>
      </div>
    );
  }
}

const styles = {
  wrapper: {
    position: 'fixed' as const,
    bottom: '0',
    width: '100%',
    backgroundColor: 'rgba(53,125,103,0.9)',
    padding: '26px 0',
    zIndex: 1000,
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 26px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  text: {
    color: '#fff',
    fontSize: '18px',
  },
  button: {
    marginLeft: '8px',
    padding: '8px 26px',
    backgroundColor: '#fff',
    color: '#27272F',
    border: '1px solid #90B49A',
    borderRadius: '9px',
    fontSize: '18px',
    transition: 'background-color 0.3s, color 0.3s',
    cursor: 'pointer',
  },
  onEnter(e: MouseEvent) {
    const t = e.currentTarget as HTMLButtonElement;
    t.style.backgroundColor = '#90B49A';
    t.style.color = '#fff';
  },
  onLeave(e: MouseEvent) {
    const t = e.currentTarget as HTMLButtonElement;
    t.style.backgroundColor = '#fff';
    t.style.color = '#27272F';
  },
};